import groq from 'groq';
import { ComponentType } from '$lib/sanity/types';
import { TextComponentFragment } from './text';
import { ImageComponentFragment } from './image';

// Accordion Item's grid items should include allowed types
// specified in `sanity-block-web/studio/schemas/components/accordionItem.ts`.
// Resolve references at all nesting levels for any components that contain them.
export const AccordionItemComponentFragment = groq`
  ...,
  contents {
    ...,
    gridItems[]{
      ...,
      component->{
        ...,
        ${ImageComponentFragment},
        ${TextComponentFragment}
      }
    }
  }
`;

export const GetAccordionItemQuery = groq`
*[_type == "${ComponentType.AccordionItem}" && _id == $id]{
  ${AccordionItemComponentFragment}
}[0]
`;

export const GetAccordionQuery = groq`
*[_type == "${ComponentType.Accordion}" && _id == $id]{
  ...,
  items[]-> {
    ${AccordionItemComponentFragment}
  }
}[0]
`;
